import { Component, OnInit, ViewChild, ElementRef, HostListener   } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ActivatedRoute } from '@angular/router';
import { Waypoint } from './live-cab-map.model';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-live-cab-map',
  standalone: true,  // Mark this component as standalone
  templateUrl: './live-cab-map.component.html',
  styleUrls: ['./live-cab-map.component.less'],
  imports: [CommonModule],  // Add CommonModule to imports for ngIf
})
export class LiveCabMapComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}
  @ViewChild('tripCard') tripCardElement!: ElementRef;
  private apiUrl = environment.apiBaseUrl;
  map: google.maps.Map | undefined;
  cabMarker: google.maps.Marker | undefined;// google.maps.marker.AdvancedMarkerElement | undefined; // Use AdvancedMarkerElement
  startPointMarker: google.maps.marker.AdvancedMarkerElement | undefined; // Use AdvancedMarkerElement
  endPointMarker: google.maps.marker.AdvancedMarkerElement | undefined; // Use AdvancedMarkerElement
  wayPointsMarkers: google.maps.marker.AdvancedMarkerElement[] = []; // Another array for different markers
  tripDetail: any;
  lastKnownLocation: any;
  previousLocation: any;
  StartDate : any;
  tripDuration: any;
  isDemo : Boolean = false;
  isDropRouteDrawn : Boolean = false;
  //Display Information
  driverMobile: any;
  currentETA : any;
  driverName: any;
  driverImage: any;
  vehicleName: any;
  guardAction: any;
  GuardImage: any; 
  guardName: any;
  startLocation: any;
  destinationLocation: any;
  startLocationFullText: any;
  destinationLocationFullText: any;
  MobileTrackeeId : any;
  TrackeeId : any;
  startTime: any;
  endTime: any;
  tripStatus: any;
  checkinOTP: any;
  checkoutOTP: any;
  TripCategory: any;
  HelplineNumber: any;
  DriverPicture: any;
  AccountURL :any;
  SiteID : any;
  isPortrait : Boolean = true;
  isMobile: Boolean = false;
  IVRNumber : any;
  Waypoints: Waypoint[] = [];
  isStarted: Boolean = false;
  isTrackingEnabled : Boolean = false;
  isTripDataReady : Boolean = false;
  tripID:any;
  isValidTrip : Boolean = false;
  intervalReferenceForTrip: any; 
  intervalReferenceForLocation: any; 
  TripCompletedTime : any;
  errorMessage: any;
  isWaypointsPlotted : Boolean = false;
  nextOTP: any;
  tripStatusCode : any;
  isEmployeeBoarded : Boolean =  false;
  center = { lat: 13.0827, lng: 80.2707 }; // Default center: Chennai
  zoom = 15; // Default zoom
  isExpanded = true; 
  PickupLocationID : any;
  DropLocationID : any;
  mapOptions: google.maps.MapOptions = {
    zoomControl: true,
    scrollwheel: true,
    disableDoubleClickZoom: true,
    maxZoom: 18,
    minZoom: 8,
  };

  directionsService: google.maps.DirectionsService | undefined;
  directionsRenderer: google.maps.DirectionsRenderer | undefined;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkOrientation();
  }

  async initMap() {
    const loader = new Loader({
      apiKey: 'AIzaSyBZdPHT8uH-iQPVCtG0fJ1rqi0Q4Lzrwno',  // Replace with your actual API key
      version: 'beta',  // Version of the API you want to load
    });
    // Import the required libraries (use 'maps' and 'marker')
    const { Map } = await loader.importLibrary('maps') as google.maps.MapsLibrary;
    const { AdvancedMarkerElement } = await loader.importLibrary('marker') as google.maps.MarkerLibrary;
    const mapElement = document.getElementById('map');
    if (mapElement) {
      // Initialize the map with the Map ID for advanced markers
      this.map = new Map(mapElement, {
        ...this.mapOptions,  // Use the options with the Map ID
        center: this.center,
        zoom: this.zoom,
        zoomControl: false, // Disables the zoom control
        streetViewControl: false, // Disables Pegman
        fullscreenControl: false, // Disables the fullscreen button
        //disableDefaultUI: true, // Disables all default UI controls
      });
      //console.log("Map is getting initialized : ", this.Waypoints);
      //this.PlotWayPoints();
      const googleMaps = google.maps;

    
      // Initialize Directions Service and Renderer
      this.directionsService = new googleMaps.DirectionsService();
      this.directionsRenderer = new googleMaps.DirectionsRenderer({
        map: this.map,
        suppressMarkers: true,
        preserveViewport: true,
        polylineOptions: {
          strokeColor: '#000000', // Solid black color
          strokeOpacity: 1.0, // Fully opaque
          strokeWeight: 4, // Thickness of the route line
        },
      });
    }

  }

  detectMobileDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    this.isMobile = /android|iPad|iPhone|iPod|windows phone/i.test(userAgent);
    //console.log("The Device is Mobile :", this.isMobile, userAgent);
  }



  getUserPoint(userPoint:any): any {
    const matchedWaypoint = this.Waypoints.find(
      (waypoint) => waypoint.wayPointReference === userPoint
    );
  
    if (matchedWaypoint) {
      return { lat: parseFloat(matchedWaypoint.latitude), long: parseFloat(matchedWaypoint.longitude) };
    }
  

    if(userPoint == this.DropLocationID){
      // Default to the last waypoint if no match is found
      const lastWaypoint = this.Waypoints[this.Waypoints.length - 1];
      return { lat: parseFloat(lastWaypoint.latitude), long: parseFloat(lastWaypoint.longitude) };
    }

    if(userPoint == this.PickupLocationID){
      // Default to the first waypoint if no match is found
      const firstWaypoint = this.Waypoints[0];
      return { lat: parseFloat(firstWaypoint.latitude), long: parseFloat(firstWaypoint.longitude) };
    }

  }

  getWaypointsToPickup():any[]{
    const points = []; 
    for(var i = 0 ; i < this.Waypoints.length; i++){
      if(this.Waypoints[i].wayPointReference == this.PickupLocationID)
        return points;

      points.push({
        location: new google.maps.LatLng(parseFloat( this.Waypoints[i].latitude), parseFloat(this.Waypoints[i].longitude)),
        stopover: true,
      }); // Add the current waypoint to the points array
    }

    return points;
  }

  getWaypointsToDrop():any[]{
    const points = []; 
    let isPickupPointReached = false;

    for(var i = 0 ; i < this.Waypoints.length; i++){

      if(this.Waypoints[i].wayPointReference == this.PickupLocationID)
      {
        isPickupPointReached = true;
      }else if(this.Waypoints[i].wayPointReference == this.DropLocationID){
        return points;
      }else{
        if(isPickupPointReached){
          points.push({
            location: new google.maps.LatLng(parseFloat( this.Waypoints[i].latitude), parseFloat(this.Waypoints[i].longitude)),
            stopover: true,
          }); // Add the current waypoint to the points array
        }
      }
    }
    return points;
  }


  drawPickupRoute(currentLocation:any) {    
    if(this.directionsService && this.directionsRenderer){
      const origin = new google.maps.LatLng(parseFloat(currentLocation.lat), parseFloat(currentLocation.long));

      const dest = this.getUserPoint(this.PickupLocationID);
      const destination = new google.maps.LatLng(dest.lat, dest.long);
      const waypoints = this.getWaypointsToPickup();
      //console.log(origin, destination, waypoints, this.Waypoints);
      this.directionsService.route(
        {
          origin,
          destination,
          waypoints,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (response, status) => {
          if (status === google.maps.DirectionsStatus.OK) {

            this.directionsRenderer?.setDirections(response);
            if(!response) return;
            // Extract travel duration
            const route = response.routes[0];
            let totalDurationInSeconds = 0;

            route.legs.forEach((leg) => {
              totalDurationInSeconds += leg.duration?.value || 0; // Total duration in seconds
            });

            // Compute ETA
            const currentTime = new Date();
            const eta = new Date(currentTime.getTime() + totalDurationInSeconds * 1000);
            const etaHours = eta.getHours().toString().padStart(2, '0');
            const etaMinutes = eta.getMinutes().toString().padStart(2, '0');
            this.currentETA = `${etaHours}:${etaMinutes}`;
          } else {
            console.error('Directions request failed due to ' + status);
          }
        }
      );

    }


  }


  drawDropRoute() {    
    //console.log(this.directionsService, this.directionsRenderer);
    if(this.directionsService && this.directionsRenderer){
      
      const originLocation = this.getUserPoint(this.PickupLocationID);
      const origin = new google.maps.LatLng(parseFloat(originLocation.lat), parseFloat(originLocation.long));
      const destinationLocation = this.getUserPoint(this.DropLocationID);      
      const destination = new google.maps.LatLng(destinationLocation.lat, destinationLocation.long);
      const waypoints = this.getWaypointsToDrop();
      
      //console.log("Redrawing Route : ", origin, destination, destination, waypoints);
      //console.log(origin, destination, waypoints, this.Waypoints);
      this.directionsService.route(
        {
          origin,
          destination,
          waypoints,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (response, status) => {
          if (status === google.maps.DirectionsStatus.OK) {

            this.directionsRenderer?.setDirections(response);
          } else {
            console.error('Directions request failed due to ' + status);
          }
        }
      );

    }


  }

  async ngOnInit(): Promise<void> {

    // Extract the 'key' parameter from the URL
    this.route.queryParams.subscribe(params => {
      const key = params['key'] ;// || localStorage.getItem('key');
      if (key) {
        
        //console.log('Tracking initiated with key :', key);

        // Store the key in local storage
        localStorage.setItem('key', key);
        this.fetchTripData();
        //this.fetchLocation();       

        this.intervalReferenceForTrip = setInterval(() => {
          //console.log("SetInterval Fetch Trip");
          this.fetchTripData();
        }, 60000);
        //console.log('TripStatus 111', this.tripStatusCode)
      }else {
        localStorage.removeItem('key');
        this.tripStatusCode = -1;
        //console.log('TripStatus', this.tripStatusCode)
        //this.setDemoDefaults();
        // If key is not provided, throw an error or handle the error
        this.handleError('The link is not valid or expired.');
      }
    });
    this.detectMobileDevice();
    this.checkOrientation();

  }

  async animateMarker(marker: google.maps.Marker, start: google.maps.LatLng, end: google.maps.LatLng, duration: number) {
    const frames = 60; // Number of frames for the animation
    const interval = duration / frames; // Time interval per frame

    const deltaLat = (end.lat() - start.lat()) / frames; // Lat increment per frame
    const deltaLng = (end.lng() - start.lng()) / frames; // Lng increment per frame
  
    let frame = 0;
  
    // Calculate rotation
    const heading = google.maps.geometry.spherical.computeHeading(start, end);

    const newIcon = await this.createRotatedIcon(
      'trackingcar.png',
      heading
    );
    marker.setIcon(newIcon);


    /*marker.setIcon({
      url: 'bluecar.png', 
      scaledSize: new google.maps.Size(36, 36), 
      anchor: new google.maps.Point(18, 18), // Anchor the center of the icon
      rotation: heading, // Set rotation dynamically
    });*/
  
    const move = () => {
      if (frame < frames) {
        const lat = start.lat() + deltaLat * frame;
        const lng = start.lng() + deltaLng * frame;
        marker.setPosition(new google.maps.LatLng(lat, lng));
        frame++;
        setTimeout(move, interval); // Schedule the next frame
      } else {
        // Ensure the marker is exactly at the end position
        marker.setPosition(end);
      }
    };
  
    move();
  }
  
  initLocationData(){    
    if(this.isTrackingEnabled || this.isStarted){
      //console.log("FirstTime FetchLocation :", this.Waypoints);
      this.fetchLocation();
    }
    this.intervalReferenceForLocation = setInterval(() => {
      if(this.isTrackingEnabled || this.isStarted){
        //console.log("SetInterval FetchLocation :", this.Waypoints);
        this.fetchLocation();
      }
    }, 15000);
  }

  PlotWayPoints(){
    // Create a single info window instance to reuse for all markers
    const infoWindow = new google.maps.InfoWindow();
    //console.log("Getting ready to Plot  Waypoints 001");
    if(this.isWaypointsPlotted) return;
    //console.log("Getting ready to Plot  Waypoints 002:", this.map , this.Waypoints);
    if(this.map && this.Waypoints){
      //console.log("Plotting Waypoints ", this.Waypoints  );

     
      this.Waypoints.forEach((waypoint, index) => {
        const latitude = parseFloat(waypoint.latitude); // Convert to number
        const longitude = parseFloat(waypoint.longitude); // Convert to number
        let displayIndex = 999;
        let iconUrl = 'poi.svg'; // Default icon for intermediate points
            if (index === 0) {
              displayIndex = 1000;
              iconUrl = 'pickup.svg'; // First location
            } else if (index === this.Waypoints.length - 1) {
              displayIndex = 1000;
              iconUrl = 'drop.svg'; // Last location
            }          
        const marker = new google.maps.Marker({
          position: { lat: latitude, lng: longitude },
          map: this.map,
          title: `${waypoint.id} - ${waypoint.wayPointName}`,
          icon: {
            url: iconUrl, 
            scaledSize: new google.maps.Size(15, 15), 
          },
          zIndex: displayIndex,
          optimized: false,
        });
         // Add click listener to display info window
         marker.addListener('click', () => {
          infoWindow.setContent(`<div><strong>${waypoint.id} - ${waypoint.wayPointName}</strong></div>`);
          infoWindow.open(this.map, marker);
        });
        this.isWaypointsPlotted = true;
      });
      
    }
  }

  initTripCards(){
    this.removeControl();
    //console.log("Removed all Cards : ", this.tripCardElement, this.map);
    /*if(this.isValidTrip && this.tripCardElement && this.map){
      //console.log('ngAfterViewInit:init', this.tripCardElement);
      const controlDiv = document.createElement('div');
      const tripCard = this.tripCardElement.nativeElement; // Use ViewChild reference   
      controlDiv.appendChild(tripCard);    
      this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(tripCard);
      //console.log("Attached to Bottom Left ");
    } */  
  }
  checkOrientation() {
    this.isPortrait = window.innerHeight > window.innerWidth;
  }

  handleError(message: string) {
    //console.error(message);
    // Example: Show an alert or display the error message on the screen
    this.errorMessage = `The link is not valid or expired.`;
  }
  
  toggleExpand(tripCard: HTMLElement) {
    //console.log('ngAfterViewInit:init:if4');
    this.isExpanded = !this.isExpanded;
    const content = tripCard.querySelector('#content-collapsible') as HTMLElement; // Cast to HTMLElement
    if (content) {
      content.style.display = this.isExpanded ? 'block' : 'none';
      const dropdownIcon = tripCard.querySelector('#dropdownIcon') as HTMLElement; // Cast to HTMLElement
      if (dropdownIcon) {
        dropdownIcon.textContent = this.isExpanded ? '▲' : '▼';
      }
    }
  }
  
  toggleExpandExt(){
    this.isExpanded = !this.isExpanded;

    // Toggle the content display
    const content = document.getElementById('contentCollapsible');
    const dropdownIcon = document.getElementById('dropdownIcon');

    const icon: any = document.getElementById('dropdownIcon');

    if (content) {
      content.style.display = this.isExpanded ? 'block' : 'none';
    }
    if (dropdownIcon) {
      dropdownIcon.textContent = this.isExpanded ?  '▼' : '▲';
    }   
    
    if (this.isExpanded) {
      icon.style.transform = 'rotate(0deg)';
    } else {
      icon.style.transform = 'rotate(180deg)';
    }
  }

  openDialer() {
    if(this.IVRNumber){

      const phoneNumber = this.IVRNumber;
      const extension = "4";
      let dialString = `tel:${phoneNumber},${extension}`;
      
      // Detect if it's an iOS device
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      
      if (isIOS) {
        // Replace `,` with `;` for iOS compatibility
        dialString = `tel:${phoneNumber};${extension}`;
      }

      //console.log("IVR:", dialString);
      window.location.href = dialString;
    }else{
      //console.log('IVR Number not available');
    }
  }

  openHelpDeskDialer(){
    if(this.HelplineNumber){
      window.location.href = 'tel:'+this.HelplineNumber;
    }
  }

  updateTripCardPosition(overlay: google.maps.OverlayView) {
    if (this.map) {
      // Update this.center with the latest latitude and longitude if needed
      const projection = overlay.getProjection();
      const position = projection.fromLatLngToDivPixel(new google.maps.LatLng(this.center.lat, this.center.lng));
      const div = document.getElementById('trip-card');
      if (div && position) {
        div.style.left = `${position.x}px`;
        div.style.top = `${position.y}px`;
      }
    }
  }
  sendSOS() {
    const key = localStorage.getItem('key');
    fetch(`${this.apiUrl}/trip/panic/v1`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        key: key,
        LocGeocode: this.lastKnownLocation
      })
    })
    .then(response => {
      // Check if the response status is OK (200-299)
      if (!response.ok) {
        // Handle different response status codes
        if (response.status === 401) {
          throw new Error('Please refresh and try again.');
        } else if (response.status === 500) {
          console.log(response);
          throw new Error('Please refresh and try again.');
        } else {
          throw new Error(`Unexpected error: ${response.status}. Please try after sometime.`);
        }
      }
      // If response is OK, return the JSON data
      return response.json();
    })
    .then(() => alert('SOS triggered successfully'))
    .catch(err => alert(err));
  }

  cleanup(){
    try{
    //console.log("Cleanup Initiated");
    //console.log("Clearing interval for location:", this.intervalReferenceForLocation);
    //console.log("Clearing interval for trip:", this.intervalReferenceForTrip);
    this.isTrackingEnabled = false;
    this.isStarted = false;
    this.tripStatusCode = -1;
    this.isValidTrip = false;
    clearInterval(this.intervalReferenceForLocation);
    clearInterval(this.intervalReferenceForTrip);
    this.driverMobile = null;
    this.tripDetail = null;
    this.tripDuration = '';

    }catch(err){
      console.log('Error:', err);
    }
  }

  getLatestLocation(data: any): any {
    const trackeeData = data?.data?.trackee?.data || [];
    const mobileTrackeeData = data?.data?.mobileTrackee?.data || [];

    // Combine both arrays
    const allData = [...trackeeData, ...mobileTrackeeData];
    if (allData.length === 0) {
      return null; // Handle empty data scenario
    }
    
    // Convert date strings to Date objects and find the latest
    const latestEntry = allData.reduce((latest, current) => {
      
      const currentDate = this.parseDate(current.ts);
      const latestDate = this.parseDate(latest?.ts);

      return currentDate > latestDate ? current : latest;
    }, allData[0]);

    return latestEntry;
  }

  private parseDate(dateString: string): Date {
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    return new Date(year, month - 1, day, hours, minutes, seconds);
  }


  fetchLocation() {
    //console.log("Fetch Location Invoked");
    const key = localStorage.getItem('key');
    let url = `${this.apiUrl}/tracking/v2?key=${key}`
    if(this.MobileTrackeeId && this.MobileTrackeeId != this.TrackeeId){
      url = url + "&mobileTrackeeId=" + this.MobileTrackeeId;
    }
    //console.log(url);
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => response.json())
    .then(async (data) =>  {
      //console.log("Location Data received ", this.Waypoints);
      if(data.status.code != 200){
        console.log("Tracking Information not available.")
        //this.cleanup();
        return;
      }
      const currentLocation = this.getLatestLocation(data);
     
      if(!this.map){
        await this.initMap();
        this.PlotWayPoints();

        if(this.isEmployeeBoarded && !this.isDropRouteDrawn){
          this.isDropRouteDrawn = true;
          this.drawDropRoute();
        }      

      }

      if (currentLocation && this.map) {
        this.lastKnownLocation = currentLocation.lat + "," + currentLocation.long;

        const lat = parseFloat(currentLocation.lat);  // Extract latitude from the response
        const lng = parseFloat(currentLocation.long); // Extract longitude from the response
        const newLatLng = new google.maps.LatLng(lat, lng);
      
        if(!this.cabMarker){
          //this.currentETA = "09:30"
          //console.log("MArker not initialized");
          this.cabMarker = new google.maps.Marker({
            title: currentLocation.ts,
            position: newLatLng,
            map: this.map, 
            icon: {
              url: 'trackingcar.png', 
              scaledSize: new google.maps.Size(36, 36), 
              anchor: new google.maps.Point(18, 18)
            },
            zIndex: 500
          });

          if(! this.cabMarker) return;

        }else{
          //console.log("MArker alread initialized");
          this.cabMarker.setTitle(currentLocation.ts);

          if(this.previousLocation){
            const heading = google.maps.geometry.spherical.computeHeading(
              this.previousLocation,
              newLatLng
            );
           const newIcon = await this.createRotatedIcon(
              'trackingcar.png',
              heading
            );
            this.cabMarker.setIcon(newIcon);
          }
          if(this.previousLocation){
            this.animateMarker(this.cabMarker, this.previousLocation, newLatLng, 2000);
          }
          
          this.previousLocation = newLatLng;
          // Update marker position
          //this.cabMarker.setPosition(newLatLng);
          
        }
       this.rePositionMap(newLatLng);
       if(!this.isEmployeeBoarded) this.drawPickupRoute(currentLocation);
      }
    })
    .catch((error) => {
      console.log("Error 1012:", error)
      clearInterval(this.intervalReferenceForLocation);
      clearInterval(this.intervalReferenceForTrip);
    });
  }


  rePositionMap(newLatLng: google.maps.LatLng) {
    // Check if the map instance exists
    if (!this.map) return;
  
    // Get the current map bounds
    const currentBounds = this.map.getBounds();
  
    if (currentBounds && currentBounds.contains(newLatLng)) {
      // If the car is within the current bounds, do nothing
      return;
    }
    //console.log('Car goes outside the scope')
    // If the car is outside the bounds, center the map on the car and maintain zoom
    this.map.setCenter(newLatLng);
  }
  
  _rePositionMap(newLatLng: google.maps.LatLng){
    const bounds = new google.maps.LatLngBounds();
    this.Waypoints.forEach((waypoint, index) => {
      const latitude = parseFloat(waypoint.latitude); // Convert to number
      const longitude = parseFloat(waypoint.longitude); // Convert to number
      const position = new google.maps.LatLng(latitude, longitude);
      bounds.extend(position);
    });
    bounds.extend(newLatLng);
    this.map?.fitBounds(bounds);
  }

  fetchTripData() {
    const key = localStorage.getItem('key');
    //console.log("Fetch TripData called");
    fetch(`${this.apiUrl}/trip/v1?key=${key}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => response.json())
    .then(data => {
      if(data == null || data.data == null) {
        console.log("Cleanup is initiated because Data is null")
        this.cleanup();
        return;
      }
      const tripData = data.data;
      this.tripStatusCode= tripData.tripStatusCode;
      this.isValidTrip = true;
      this.initTripCards();

      this.StartDate = new Date(tripData.startTime); 
      const startTime = new Date(tripData.startTime);  // Parse the StartTime
      const starthours = startTime.getHours().toString().padStart(2, '0'); // Extract hours
      const startminutes = startTime.getMinutes().toString().padStart(2, '0'); // Extract minutes
      const endTime = new Date(tripData.endTime);  // Parse the StartTime
      const endhours = endTime.getHours().toString().padStart(2, '0'); // Extract hours
      const endminutes = endTime.getMinutes().toString().padStart(2, '0'); // Extract minutes

      this.processStateData(tripData);

      this.TripCategory = tripData.category;
      this.startLocation = this.GetTruncatedText(tripData.source.name);
      this.startLocationFullText = tripData.source.name;
      this.destinationLocation = this.GetTruncatedText(tripData.destination.name);
      this.destinationLocationFullText = tripData.destination.name;
      this.startTime = `${starthours}:${startminutes}`;
      this.endTime = `${endhours}:${endminutes}`;
      this.tripID = tripData.tripStatusCode;
      this.tripDetail = `Trip Detail : ${tripData.vehicle.routeName}`;
      this.tripDuration = `Trip Time : ${starthours}:${startminutes} - ${endhours}:${endminutes}`;
      this.TripCompletedTime = tripData.tripCompletedTime
      if(this.TripCompletedTime != null){
        this.tripStatusCode = 6;
      }
     /* if (tripData.tripStatusCode >= 3){
        // Call fetchLocation every 15 seconds to update location
        this.intervalId = setInterval(() => {
          this.fetchTripData();
        }, 60000);
      }*/
      if(!this.isTripDataReady){
        //console.log("if(!this.isTripDataReady){: ", this.Waypoints );
        this.isTripDataReady = true;
        this.initLocationData();
      }
      if(this.tripStatusCode >= 5){
        console.log("Trip is completed")
        this.cleanup();
      }

    })
    .catch((error) => {
      console.log("Cleanup is initiated because of Exception ", error)
      this.cleanup();
      
      //this.setDemoDefaults();
    });
  }

  processStateData(tripData:any){
    /*switch(data.Detail.TripCategory){
      case 'OWP' : this.TripCategory = 'Pickup-One way';break;
      case 'OWD' : this.TripCategory = 'Drop-One way';break;
      case 'RT' : this.TripCategory = 'Return';break;
      case 'REN' : this.TripCategory = 'Rental';break;
      case 'OSD' : this.TripCategory = 'Outstation-Drop';break;
      case 'OSR' : this.TripCategory = 'Outstation-Return Trip';break;
      case 'P' : this.TripCategory = 'Regular Pickup'; break;
      case 'D' : this.TripCategory = 'Regular Drop'; break;
      default: this.TripCategory = "Normal Trip"
    }*/
    //console.log("TripData:", tripData);
    this.Waypoints = tripData.waypoints;
    
    this.PickupLocationID = tripData.pickupLocationID;
    this.DropLocationID = tripData.dropLocationID;

    this.AccountURL = tripData.accountURL;
    this.SiteID = tripData.siteID;
    ///console.log("Waypoints 001:", this.Waypoints);

    if(tripData.guard){
      this.guardName = tripData.guard.name;
      this.guardAction =  " will escort you";
      this.GuardImage = this.AccountURL + "/integration/LoadDriverImage?ImgName=" + tripData.guard.image + "&SiteID=" + this.SiteID;
      //console.log(this.GuardImage);
    }else{
      this.guardName = null;
    }

    this.tripStatus = this.GetTripStatus(tripData);
    if(tripData.tripStatusCode >= 3){
      this.guardAction = " is escorting you";
    }
   
    if(tripData.tripStatusCode >= 3){
      this.nextOTP = tripData.checkoutOTP;
    }else{
      this.nextOTP = tripData.checkinOTP;;
    }
    
    if(!this.isEmployeeBoarded){
      //console.log("Employee is not yet boarded");
      this.isEmployeeBoarded = (tripData.tripStatusCode == 4);      
    }
    
    this.isStarted = (tripData.tripStatusCode >= 3);

    if(!this.isStarted){
      const currentTime = new Date();
      
      // Calculate the difference in milliseconds
      const timeDifference = this.StartDate.getTime() - currentTime.getTime();
      
      // Convert the difference to minutes
      const timeDifferenceInMinutes = timeDifference / (1000 * 60);
      //console.log("The time Difference is ", timeDifferenceInMinutes);
      // Check if the difference is less than or equal to 30 minutes
      this.isTrackingEnabled = timeDifferenceInMinutes <= 30;
      
    }else{
      const currentTime = new Date();
      const endTime = new Date(tripData.endTime);

      //console.log("The Trip is :", tripData);


      // Calculate the difference in milliseconds
      const timeDifference = currentTime.getTime() - endTime.getTime();
      
      // Convert the difference to minutes
      const timeDifferenceInMinutes = timeDifference / (1000 * 60);
      
      // Check if the difference is less than or equal to 60 minutes
      if(timeDifferenceInMinutes >= 60){
        console.log("Cleanup is initiated because the Timedifference is >= 60 ", timeDifferenceInMinutes)
        this.cleanup();
        return;
      }

      this.isTrackingEnabled = true;
    }
    this.driverMobile = tripData.driver.mobile;
    this.driverName = tripData.driver.name;
    this.driverImage = tripData.driver?.image || "";
    this.vehicleName = tripData.vehicle.vehicleReg;
    this.MobileTrackeeId = tripData.vehicle.mobileTrackeeID;
    this.TrackeeId = tripData.vehicle.trackeeID;


    if(this.driverImage != null){
      this.DriverPicture = this.AccountURL + "/integration/LoadDriverImage?ImgName=" + this.driverImage + "&SiteID=" + this.SiteID;
    }else{
      this.DriverPicture = null;
    }

    this.HelplineNumber = tripData.helplineNumber;
    this.IVRNumber = tripData.ivrNumber
    //console.log("IVR Number is ", tripData);
  }

  GetTruncatedText(data:any){
    if (data.length > 50) {
      return data.substring(0, 45) + "...";
    }
    return data;
  }

  getMinifiedAddress(location: string) {
    if(location == null) return "";
    if(location.length <= 45)
      return location
    else
      return location.substring(0, 45) + "...";
} 
  GetTripStatus(tripData:any){

    switch(tripData.tripStatusCode){
      case 0: return 'Booked';
      case 1: return 'Confirmed';
      case 2: return 'Vehicle Allocated';
      case 3: return 'Started';
      case 4: return 'Boarded';
      case 5: return 'Completed';
      case 6: return 'Closed';
      default: return 'Booked';
    }
  }
  removeControl() {
    if (this.map) {
      //this.map.controls[google.maps.ControlPosition.TOP_CENTER].clear();
      //this.map.controls[google.maps.ControlPosition.LEFT_TOP].clear();
      //this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].clear();
    }
  }
  setDemoDefaults(){
    if(this.isDemo){
      this.TripCategory = "Trip category"
      this.driverMobile = "0000000000";
      this.driverName = "TestDriver";
      this.driverImage = "";
      this.vehicleName = "KA12J1010";
      this.guardName = "Sivakarthikeyan";
      this.startLocation = "Indira Nagar";
      this.destinationLocation = "Tin Factory";
      this.startTime = "12:00";
      this.endTime = "13:23";
      this.tripStatus = "Vehicle Assigned";
      this.checkinOTP = "1111";
      this.checkoutOTP = "2222";
      this.tripID = "00056789-542";
      this.tripStatusCode = 2;
      this.isValidTrip = true;
      this.guardAction =  " will escort you";
    }
    this.initTripCards();
  }

  createRotatedIcon(url: any, angle: any) : Promise<any> {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const image = new Image();
    image.src = url;
    if (!context) {
      return Promise.reject(new Error("Failed to get 2D context for canvas"));
    }
  
    return new Promise((resolve) => {
      image.onload = () => {
        //console.log("The Image attributes are ",  image.width, image.width);
        canvas.width = image.width;
        canvas.height = image.width;
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.save();
        context.translate(canvas.width / 2, canvas.height / 2);
        context.rotate((angle * Math.PI) / 180);
        context.drawImage(image, -image.width / 2, -image.height / 2);
        context.restore();
  
        resolve({
          url: canvas.toDataURL(),
          scaledSize: new google.maps.Size(36, 36), 
          anchor: new google.maps.Point(18, 18), // Anchor the center of the icon
        });
      };
    });
  }
  
}
